import React, { useState, useEffect } from 'react';
import './Modal.css';

function Modal({ isOpen, onClose, title, children }) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsMounted(true);
    } else {
      // When closing, wait for animation to finish before unmounting
      const timer = setTimeout(() => {
        setIsMounted(false);
      }, 300); // This must match your CSS animation duration
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const handleClose = () => {
    onClose(); // Tell the parent to set isOpen to false
  };

  if (!isMounted) {
    return null;
  }

  return (
    <div 
      className={`modal-overlay ${!isOpen ? 'closing' : ''}`}
      onClick={handleClose}
    >
      <div 
        className={`modal ${!isOpen ? 'closing' : ''}`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        <div className="modal-header">
          <h3>{title}</h3>
          <span 
            className="modal-close-x" 
            role="button" 
            tabIndex={0} 
            aria-label="Close" 
            onClick={handleClose}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClose(); }}
          >
            ×
          </span>
        </div>
        <div className="modal-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal; 
 